import { c as _c } from "react/compiler-runtime";
import UserRateAdjustmentHelperValue from "./UserRateAdjustmentHelperValue";
export default function UserRateAdjustmentHelper(t0) {
  const $ = _c(9);
  const {
    inLineValues,
    originalValue,
    adjustedValue,
    adjustmentType
  } = t0;
  const t1 = `${inLineValues ? "tw-mt-2 tw-flex tw-flex-wrap tw-gap-y-1 tw-gap-x-4" : "tw-grid tw-grid-cols-2 tw-gap-2 tw-mb-4"} `;
  const t2 = `Current ${adjustmentType}:`;
  let t3;
  if ($[0] !== originalValue || $[1] !== t2) {
    t3 = <UserRateAdjustmentHelperValue value={originalValue} title={t2} />;
    $[0] = originalValue;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = adjustedValue - originalValue;
  let t5;
  if ($[3] !== t4) {
    t5 = <UserRateAdjustmentHelperValue value={t4} title="Adjustment:" />;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t1 || $[6] !== t3 || $[7] !== t5) {
    t6 = <div className={t1}>{t3}{t5}</div>;
    $[5] = t1;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}